import React, { useEffect, useRef, useState, Fragment } from "react";
import S from "./Skeleton.styled";
export const ChannelItemSkeleton = () => {
    const [heightContainer, setHeight] = useState(0);
    const divRef = useRef(null);
    useEffect(() => {
        if (divRef.current) {
            setHeight(divRef.current.clientHeight);
        }
    }, []);
    const populate = () => {
        const skeletonDivs = [];
        for (let i = heightContainer; i > 0; i -= 80) {
            skeletonDivs.push(React.createElement(Fragment, { key: i },
                React.createElement(S.Line, null,
                    React.createElement(S.SkeletonPulse, { width: "2em", height: "2em" }),
                    React.createElement(S.LineWrapper, null,
                        React.createElement(S.SkeletonPulse, { width: "10em", height: "0.75em" }),
                        React.createElement(S.Spacer, null),
                        React.createElement(S.SkeletonPulse, { width: "15em", height: "0.75em" }))),
                React.createElement(S.Spacer, null)));
            if (i < 80) {
                skeletonDivs.push(React.createElement(S.LineWrapper, { key: i + 500 },
                    React.createElement(S.SkeletonPulse, { width: "37em", height: "40px" })));
                break;
            }
        }
        return skeletonDivs;
    };
    return (React.createElement(S.Wrapper, { ref: divRef },
        React.createElement(S.Header, null,
            React.createElement(S.SkeletonPulse, { width: "20%", height: "20px" })),
        populate()));
};
export default ChannelItemSkeleton;
//# sourceMappingURL=Skeleton.js.map